import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import ProfileScreen from '../screen'
import UserGoalModal from '../../goals/edit-modal'

const UsersRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.PROFILE} component={ProfileScreen} />
            <Route exact path={`${CLIENT_ENDPOINTS.PROFILE}${CLIENT_ENDPOINTS.USER_GOAL}`} component={UserGoalModal} />
        </React.Fragment>
    )
}

export default UsersRoutes